<template>
  <el-row :gutter="5">
    <el-col :span="showExportData ? 18 : 24" :md="showExportData ? 16 : 24">
      
    </el-col>
    <el-col :span="6" :md="8" v-show="showExportData">
      <el-button size="small" plain @click="handleExportData">导出</el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    search: Function,
    exportData: Function
  },
  methods: {
    handleSearch () {
      this.search()
    },
    handleExportData () {
      if (this.showExportData) {
        this.exportData()
      }
    }
  },
  computed: {
    showExportData () {
      return typeof this.exportData === 'function'
    }
  }
}
</script>

<style scoped>
.el-button {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/search-reset.vue